const statistical = {
  isSelect: "请选择要打包的数据",
  noSuccess: "下载失败",
  operation: {
    month: "日期",
    aperationMileage: "里程(km)",
    aperationTiemLenthen: "时长(min)",
    oil: "油耗(L)",
    oilPay: "油费(铢)",
    carbonEmission: "碳排放量(kg)",
    licenseplate: "请输入车牌号码",
    searchWidth: {
      width1: "60px",
      width2: "75px",
      width3: "60px"
    },
    allAperationMileage: "总运营里程",
    allAperationTiemLenthen: "总运营时长",
    allOil: "总油耗",
    tripCount: "行程数",
    score: "驾驶行为评分",
    sharpturn: "急转弯次数",
    emergencyBrake: "急减速次数",
    rapidAcceleration: "急加速次数",
    emergencyBrakeWidth: "150px",
    rapidAccelerationWidth: "150px",
    sharpturnWidth: "150px"
  },
  hisDownloadSearch: {
    missionName: "任务名称",
    downloadType: "下载类型",
    downloadStatus: "下载状态",
    searchLabelWidth: "80px",
    searchLabelWidth1: "65px",
    searchTitle: "下载子任务列表",
    downloadPackage: "打包下载"
  },
  hisDownloadTabel: {
    taskType: "任务类型",
    downloadedVehicles: "下载车辆数",
    downloadProgress: "下载进度",
    downloader: "创建人",
    taskCreationTime: "任务创建时间",
    instructions: "说明",
    start: "初始化",
    queue: "排队中",
    processing: "进行中",
    compressing: "压缩中",
    completed: "已完成",
    abnormal: "异常",
    noHistoricalData: "无历史数据",
    commonTasks: "普通任务",
    urgentTasks: "紧急任务",
    startTime: "下载开始时间",
    endTime: "下载结束时间"
  },
  hisDownloadTabelWidth: {
    tabelWidth1: "100px",
    tabelWidth2: "100x",
    tabelWidth3: "140px"
  },
  hisTips: {
    taskInfo: "任务进行中，不可删除",
    isDelete: "是否删除",
    isSelect: "请选择任务",
    noSuccess: "任务下载状态未完成",
    stateInfo: "任务不能设置任务类型"
  },
  boxAddTask: {
    addTask: "添加任务",
    selectVehicle: "选择车辆",
    selectParameters: "选择参数",
    carInfo: "当前未选择任何车辆",
    tabelWidth: "70px",
    select: "已选择",
    selectDes: "辆车",
    operatingArea: "营运区域",
    terminalNumber: "终端编号",
    brand: "品牌",
    model: "车型",
    series: "系列",
    projectCode: "项目代号",
    modelName: "车型名称",
    forCar: "商品车",
    ignites: "试验车",
    standardCar: "对标车",
    error: {
      selectTaskName: "请输入任务名称",
      selectVehicle: "请选择车辆",
      selectStartTime: "请选择开始时间",
      selectEndTime: "请选择结束时间",
      selectDownloadType: "请选择下载类型",
      selectTimes: "开始时间不能大于结束时间，请重新选择"
    },
    parameters: {
      parameterName: "参数名称"
    },
    width1: "75px",
    width2: "75px"
  },
  tripvicel: {
    downOBD: "设备总数",
    obdwidth: "90px",
    carInfo: "您未选择任何OBD设备",
    selectDes: "OBD设备",
    samplingRate: "采样率",
    errorsamplingRate: "请输入采样率",
    querytime: "下载耗时"
  }
} 
export default statistical